<script lang="ts" setup>
import { AvailableUpdatePackageInfo } from '@/api/generator';
import DateTimeFormatter from '@/components/formatters/DateTimeFormatter.vue';

export type AvailableUpdateInfoProps = {
  modelValue: AvailableUpdatePackageInfo;
  headline: string;
};

defineProps<AvailableUpdateInfoProps>();
</script>

<template>
  <div v-if="modelValue?.version" class="text-body-1 mb-5">
    <div v-if="modelValue?.releaseDate">
      <v-label>
        {{ `${$t('ReleasedOn')}` }}
      </v-label>

      <div>
        <DateTimeFormatter :value="modelValue.releaseDate" />
      </div>
    </div>
  </div>
</template>
